// extracted by mini-css-extract-plugin
export var accordion = "fj_lH";
export var accordionContent = "fj_lJ";
export var figure = "fj_lG";